import React, {
  useEffect,
  useRef
} from "react";
import StepConnector, {
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import { stageList } from "../../../Models/Status";
import { CustomConnectorstyles } from "./CustomStepConnectorStyles";
import "./CustomStepConnector";

interface CustomConnector {
  visible: boolean;
}

export const CustomStepConnector: React.FC<CustomConnector> = ({ visible }): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const transitionDelay = 0.25;

  useEffect(() => {
    // Weird way to add a failed class to the connector of the failed state
    // MUI doesnt provide a comfortable way to achieve this so have to use direct html option
    if (ref?.current?.parentElement?.querySelector('span.MuiStepLabel-label')?.textContent?.trim() === stageList.Unzustellbar) {
      ref.current.querySelector('.MuiStepConnector-alternativeLabel')?.classList.add('failed-step');
    }
  });

  const Styleddiv = styled(StepConnector)(() => ({
    ...CustomConnectorstyles({ visible, transitionDelay }),
  }));

  return (
    <div ref={ref} style={{ display: "flex" }} >
      <Styleddiv />
    </div>
  );
};
